import React from 'react';
import { IDP_PRESETS, type IdpProvider } from './idp-presets';

export interface IdpTypeStepProps {
  /** Currently selected provider */
  readonly value: IdpProvider;
  /** Callback when the provider selection changes */
  readonly onChange: (provider: IdpProvider) => void;
}

/**
 * Step 1 of the IdP Configuration Wizard.
 * Lets the admin choose a known identity provider (with pre-filled config)
 * or a custom OIDC/SAML provider.
 */
export function IdpTypeStep({ value, onChange }: IdpTypeStepProps): React.ReactElement {
  return (
    <fieldset className="space-y-3">
      <legend className="text-sm font-medium leading-none mb-2">Choose your Identity Provider</legend>

      {IDP_PRESETS.map((preset) => (
        <label
          key={preset.id}
          className={`flex items-start gap-3 rounded-lg border p-4 cursor-pointer transition-colors ${
            value === preset.id
              ? 'border-primary bg-primary/5'
              : 'border-input hover:border-primary/50 hover:bg-accent/5'
          }`}
        >
          <input
            className="mt-0.5 h-4 w-4 border border-input text-primary focus:ring-2 focus:ring-ring"
            type="radio"
            name="idp-provider"
            value={preset.id}
            checked={value === preset.id}
            onChange={(e) => onChange(e.target.value as IdpProvider)}
          />
          <div>
            <span className="text-sm font-medium">{preset.name}</span>
            <p className="text-xs text-muted-foreground mt-0.5">{preset.description}</p>
          </div>
        </label>
      ))}
    </fieldset>
  );
}
